module.exports = __webpack_public_path__ + "static/daddycuddlesvest-b06595e1811d371acd003716d829bbd5.jpeg";